import { ObserveState } from "../../CommonUI/StateManagement/ObserveState";
import { useRef, useState } from "react";
import { TextField } from "@mui/material";
import { Box, Grid } from "@mui/material";
import { ExpressionView, ExpressionViewEmptyBehavior } from "../../Expressions/ExpressionView";
import { UILabel } from "../../CommonUI/BuildlingBlocks/UILabel";
import { UIStyleConstants } from "../../rule-engine-core/Common/UIStyleConstants";
import { UIButton } from "../../CommonUI/BuildlingBlocks/UIButton";
import { TextSubstitutionConfiguration } from "../../rule-engine-core/TextMerge/TextSubstitutionConfiguration";
import { TextSubstitutionUtility } from "../../rule-engine-core/TextMerge/TextSubstitutionUtility";
import { UIStandardLayer } from "../../CommonUI/BuildlingBlocks/UIStandardLayer";

export function TextSubstitutionEditor(props: { config: TextSubstitutionConfiguration }) {
    const textFieldRef = useRef<HTMLInputElement>(null);
    const [val, setVal] = useState<string>(props.config.text);
    const [selection, setSelection] = useState<{ begin: number; end: number } | undefined>();
    const [action, setAction] = useState<"add" | "edit" | undefined>();
    const [selectedField, setSelectedField] = useState<string | undefined>();
    const [newField, setNewField] = useState<string>();

    return (
        <ObserveState
            listenTo={props.config}
            properties={["text", "fields"]}
            control={() => {
                return (
                    <>
                        {action !== undefined && (
                            <UIStandardLayer
                                open={action !== undefined}
                                title={action === "edit" ? "Edit Field Name" : "New Field Name"}
                                renderUI={() => {
                                    return (
                                        <TextField
                                            variant={"outlined"}
                                            autoFocus={true}
                                            value={newField}
                                            onChange={(t) => setNewField(t.target.value)}
                                        />
                                    );
                                }}
                                primaryActionText={"Done"}
                                onPrimaryAction={() => {
                                    if (selection) {
                                        props.config.text =
                                            props.config.text.substring(0, selection.begin) +
                                            "[!" +
                                            newField +
                                            "!]" +
                                            props.config.text.substring(selection.end);
                                        setVal(props.config.text);
                                        setSelectedField(newField);
                                    }
                                    setAction(undefined);
                                }}
                            />
                        )}
                        <Grid
                            padding={"10px"}
                            container={true}
                            columns={3}
                            minWidth={"900px"}
                            width={"100%"}
                            height={"100%"}
                        >
                            <Grid
                                item={true}
                                xs={1}
                                paddingRight={"10px"}
                            >
                                <Box
                                    display={"flex"}
                                    flexDirection={"column"}
                                >
                                    <Box paddingBottom={"10px"}>
                                        <UILabel>Fields</UILabel>
                                    </Box>
                                    {props.config.getFields().map((d) => {
                                        return (
                                            <Box
                                                paddingLeft={"10px"}
                                                display={"flex"}
                                                flexDirection={"row"}
                                                justifyContent={"space-between"}
                                                alignItems={"center"}
                                                borderRadius="3pxpx"
                                                border={
                                                    selectedField === d.name
                                                        ? "1px solid " + UIStyleConstants.GRAY_COLOR
                                                        : undefined
                                                }
                                            >
                                                <UILabel>
                                                    {d.name} {!d.used && <> [Unused]</>}
                                                </UILabel>

                                                <ExpressionView
                                                    expression={d.config}
                                                    emptyBehavior={ExpressionViewEmptyBehavior.VARIABLE}
                                                />
                                            </Box>
                                        );
                                    })}
                                    {props.config.getFields().length === 0 && (
                                        <Box
                                            display={"flex"}
                                            justifyContent={"center"}
                                        >
                                            <UILabel>[No Fields]</UILabel>
                                        </Box>
                                    )}
                                </Box>
                            </Grid>
                            <Grid
                                item={true}
                                xs={2}
                                paddingBottom={"15px"}
                            >
                                <Box
                                    display={"flex"}
                                    flexDirection={"column"}
                                    height={"100%"}
                                >
                                    <Box
                                        paddingBottom={"10px"}
                                        display={"flex"}
                                        flexDirection={"row"}
                                        justifyContent={"end"}
                                    >
                                        {selectedField && (
                                            <UIButton
                                                onClick={() => {
                                                    setNewField(selectedField);
                                                    setAction("edit");
                                                }}
                                            >
                                                Edit [{selectedField}]
                                            </UIButton>
                                        )}
                                        {!selectedField && (
                                            <UIButton
                                                onClick={() => {
                                                    setNewField(undefined);
                                                    setAction("add");
                                                }}
                                            >
                                                Add Field
                                            </UIButton>
                                        )}
                                    </Box>
                                    <Box
                                        width={"100%"}
                                        height={"100%"}
                                    >
                                        <ObserveState
                                            listenTo={props.config}
                                            properties={["text"]}
                                            control={() => {
                                                return (
                                                    <TextField
                                                        style={{ height: "100%", width: "100%" }}
                                                        ref={textFieldRef}
                                                        multiline={true}
                                                        minRows={25}
                                                        size={"small"}
                                                        variant={"outlined"}
                                                        value={val}
                                                        onChange={(e) => {
                                                            setVal(e.target.value);
                                                            props.config.text = e.target.value;
                                                        }}
                                                        onSelectCapture={(e) => {
                                                            let newRange = TextSubstitutionUtility.correctSelection(
                                                                val,
                                                                // @ts-ignore
                                                                e.target.selectionStart,
                                                                // @ts-ignore
                                                                e.target.selectionEnd,
                                                                true,
                                                            );

                                                            if (newRange) {
                                                                // @ts-ignore
                                                                e.target.setSelectionRange(
                                                                    newRange.newBegin,
                                                                    newRange.newEnd,
                                                                );
                                                                setSelectedField(
                                                                    TextSubstitutionUtility.getSelectedField(
                                                                        val,
                                                                        newRange.newBegin,
                                                                        newRange.newEnd,
                                                                    ),
                                                                );

                                                                setSelection({
                                                                    begin: newRange.newBegin,
                                                                    end: newRange.newEnd,
                                                                });
                                                            } else {
                                                                setSelectedField(
                                                                    TextSubstitutionUtility.getSelectedField(
                                                                        val,
                                                                        // @ts-ignore
                                                                        e.target.selectionStart,
                                                                        // @ts-ignore
                                                                        e.target.selectionEnd,
                                                                    ),
                                                                );
                                                                setSelection({
                                                                    // @ts-ignore
                                                                    begin: e.target.selectionStart,
                                                                    // @ts-ignore
                                                                    end: e.target.selectionEnd,
                                                                });
                                                            }
                                                        }}
                                                    ></TextField>
                                                );
                                            }}
                                        />
                                    </Box>
                                </Box>
                            </Grid>
                        </Grid>
                    </>
                );
            }}
        />
    );
}
